import * as React from 'react';
import FormLabel from '@mui/material/FormLabel';

export default function Label(props) {
  return (
    <FormLabel {...props}>{props.children}</FormLabel>
  );
}
